import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthGoogle() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    const state = params.get("state");
    const saved = sessionStorage.getItem("g_oauth_state");
    const mode = sessionStorage.getItem("g_oauth_mode");
    if (params.get("error")) { setError("Google sign-in was cancelled."); return; }
    if (!code) { setError("Missing authorization code."); return; }
    if (saved && state && saved !== state) { setError("Security check failed. Please try signing in again."); return; }
    sessionStorage.removeItem("g_oauth_state");
    sessionStorage.removeItem("g_oauth_mode");
    (async () => {
      try {
        const redirectUri = window.location.origin + "/auth/google";
        if (mode === "link") {
          const { data } = await api.post("/auth/google/link", { code, redirect_uri: redirectUri });
          setUser(data);
          toast.success("Google connected to your account.");
          navigate("/app/account", { replace: true });
          return;
        }
        const { data } = await api.post("/auth/google/callback", { code, redirect_uri: redirectUri });
        setUser(data);
        navigate(data.role === "admin" ? "/admin" : data.onboarded ? "/app" : "/onboarding", { replace: true });
      } catch (e) { setError(apiError(e)); }
    })();
  }, [params, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="auth-google-page">
      <div className="gapped-enclosure max-w-md w-full p-10 text-center">
        {error ? (
          <>
            <span className="t-label">Sign in</span>
            <p className="t-small status-blocked mt-3" data-testid="auth-google-error">{error}</p>
            <Link to="/login" className="btn-ghost inline-block mt-6" data-testid="auth-google-back">Back to sign in</Link>
          </>
        ) : (
          <p className="t-small text-muted-s" data-testid="auth-google-loading">Completing your Google sign-in...</p>
        )}
      </div>
    </div>
  );
}
